import { IconClose } from 'src/icons';

export interface SelectedFilter {
  type: string;
  value: string;
  originalValue?: any;
}

interface SelectedFiltersProps {
  filters: SelectedFilter[];
  onRemoveFilter: (filter: { type: string; originalValue?: any }) => void;
}

export const SelectedFilters = ({ filters, onRemoveFilter }: SelectedFiltersProps) => {
  if (filters.length === 0) return null;

  return (
    <div className="mb-6 flex flex-wrap items-center gap-4 text-body-sm-desktop text-neutral-300">
      <span className="text-loud-sm-desktop text-neutral-300">Selected filters</span>
      {filters.map((filter, index) => (
        <div key={index} className="flex items-center gap-2 rounded-e bg-neutral-white px-2 py-1">
          <span className="text-loud-sm-desktop text-neutral-100">{filter.value}</span>
          <button
            onClick={() => onRemoveFilter(filter)}
            className="cursor-pointer text-neutral-300 hover:text-neutral-100"
          >
            <IconClose />
          </button>
        </div>
      ))}
    </div>
  );
};
